import { api } from "../lib/api";

export interface UploadTaskDocumentParams {
	file: File;
	taskKey: string;
	requiredDocumentKey: string;
	documentType?: string;
	journeyId?: string;
	notes?: string;
}

export interface TaskDocumentUploadResponse {
	id: string;
	taskId: string;
	taskKey: string;
	documentId: string;
	requiredDocumentKey: string;
	documentType: string | null;
	journeyId: string | null;
	status: "uploaded" | "accepted" | "rejected";
	fileName: string;
	uploadedAt: string;
}

export async function uploadTaskDocument(
	params: UploadTaskDocumentParams,
): Promise<TaskDocumentUploadResponse> {
	const form = new FormData();
	form.append("file", params.file);
	form.append("taskKey", params.taskKey);
	form.append("requiredDocumentKey", params.requiredDocumentKey);
	if (params.documentType) form.append("documentType", params.documentType);
	if (params.journeyId) form.append("journeyId", params.journeyId);
	if (params.notes) form.append("notes", params.notes);

	const response = await api.post<TaskDocumentUploadResponse>(
		"/api/task-document-uploads",
		form,
	);
	return response.data;
}
